const ZOOM_BREAKPOINT = 0.6;

const DESCRIPTION_HEIGHT = '145px';
const MIN_DESCRIPTION_WIDTH = 400;

const RESIZE_CURSOR_AREA = 10;

export { ZOOM_BREAKPOINT, MIN_DESCRIPTION_WIDTH, DESCRIPTION_HEIGHT, RESIZE_CURSOR_AREA };
